
import ITarefa from "../interfaces/ITarefa";
import { defineComponent, PropType } from "vue";
import Cronometro from "./Cronometro.vue";
import Box from "./Box.vue";

export default defineComponent({
  name: "Tarefa",
  emits: ["aotarefaClicked"],
  components: { Cronometro, Box },
  props: {
    tarefa: {
      type: Object as PropType<ITarefa>,
      required: true,
    },
  },

  methods: {
    /**
     * Tarefa Clicada
     *@description
     *19/09/20/22 vlima Faz a emissão do evento ao clicar em qualquer parte da tarefa
     */
    tarefaClicked(): void {
      this.$emit("aotarefaClicked", this.tarefa);
    },
  },
});
